import {Navigate, useSearchParams} from 'react-router-dom';
import {getTelephonyDetailsPathname} from '../../Helpers/ServiceHelper';

interface LegacyTelephonyRedirectProps {
  suffix?: string;
}

/**
 * Redirige les anciennes URL `details-telephonie?cisId=…` / `details-appels?cisId=…`
 * (favoris, liens externes) vers `/services/telephonie/{serviceId}[suffix]`.
 */
const LegacyTelephonyRedirect = ({suffix = ''}: LegacyTelephonyRedirectProps): JSX.Element => {
  const [searchParams] = useSearchParams();
  const cisId = searchParams.get('cisId');

  if (!cisId) {
    return <Navigate to="/services/telephonie/liste" replace />;
  }

  const params = new URLSearchParams(searchParams);
  params.delete('cisId');
  params.delete('serviceName');
  const search = params.toString();

  return (
    <Navigate
      to={`${getTelephonyDetailsPathname(cisId)}${suffix}${search ? `?${search}` : ''}`}
      replace
    />
  );
};

export default LegacyTelephonyRedirect;
